import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  codeLogin: ['numberList'],
  codeLoginSuccess: [
    'memberId',
    'realName',
    'schoolId',
    'nickName',
    'schoolName',
  ],
  codeLoginFailed: ['errMsg'],
  getToken: null,
  inputNumber: ['numberList'],
  logout: null,
  logoutSuccess: null,
  logoutFailed: null,
  clearError: null,
  reload: null,
  getBaseInfo: ['autoconnecting'],
  restoreConnectStatus: null,
  setPristine: null,
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  numberList: new Array(6).fill(''),
  startConnectWs: ['token'],
  errMsg: '',
  token: '',
  // 是否登录成功
  isLoginSucess: false,
  // 是否需要退出登录
  needLogout: false,
  code: '',
  memberId: null,
  realName: null,
  schoolId: null,
  nickName: null,
  schoolName: null,
  autoconnecting: false,
  pristine: true,
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.CODE_LOGIN]: (state = INITIAL_STATE, action) => ({
    ...state,
    code: action.numberList.join(''),
  }),
  [Types.CODE_LOGIN_FAILED]: (state = INITIAL_STATE, action) => ({
    ...state,
    errMsg: action.errMsg,
    needLogout: action.needLogout,
  }),
  [Types.INPUT_NUMBER]: (state = INITIAL_STATE, action) => ({
    ...state,
    numberList: action.numberList,
  }),
  [Types.CODE_LOGIN_SUCCESS]: (state = INITIAL_STATE, action) => ({
    ...state,
    numberList: INITIAL_STATE.numberList,
    memberId: action.memberId,
    realName: action.realName,
    schoolId: action.schoolId,
    nickName: action.nickName,
    schoolName: action.schoolName,
    isLoginSucess: true,
    autoconnecting: true, // 这个时候把autoconnecting也设置成true，让页面不在停留在输入投屏码的页面，为了兼容原来逻辑
    pristine: false,
  }),
  [Types.SET_PRISTINE]: (state = INITIAL_STATE, action) => ({
    ...state,
    pristine: false,
  }),
  [Types.CLEAR_ERROR]: (state = INITIAL_STATE) => ({
    ...state,
    errMsg: INITIAL_STATE.errMsg,
    needLogout: INITIAL_STATE.needLogout,
  }),
  [Types.GET_BASE_INFO]: (state = INITIAL_STATE) => ({
    ...state,
    autoconnecting: true,
  }),
  [Types.RESTORE_CONNECT_STATUS]: (state = INITIAL_STATE) => ({
    ...state,
    autoconnecting: false,
  }),
});
